var React = require('react');

function Creditcard (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M68.24,5.36A11.87,11.87,0,0,0,51.82,1.93L5.39,32.23A11.88,11.88,0,0,0,1.92,48.65L5,53.43,71.36,10.15ZM7,44.46a5.41,5.41,0,0,1,2-6.82L55.35,7.34a5.42,5.42,0,0,1,7,1Z","fill":"#2a2d58","key":1}),React.createElement("path",{"d":"M82.47,27.16,74.7,15.26,8.38,58.54l7.76,11.9a11.88,11.88,0,0,0,16.43,3.44L79,43.58a11.88,11.88,0,0,0,3.47-16.42Zm-4.66,7.59a5.38,5.38,0,0,1-2.34,3.41L29,68.47a5.41,5.41,0,0,1-7.48-1.56l-4.24-6.49L72.82,24.2l4.23,6.49A5.34,5.34,0,0,1,77.81,34.75Z","fill":"#2a2d58","key":2}),React.createElement("path",{"d":"M70.62,39.33a4.27,4.27,0,0,1-3.44.54,4.27,4.27,0,1,1-3.1-4.76,4.27,4.27,0,1,1,6.54,4.22Z","fill":"#f1b860","key":3})]);
}

Creditcard.defaultProps = {"viewBox":"0 0 84.39 75.81"};

module.exports = Creditcard;

Creditcard.default = Creditcard;
